import { render, staticRenderFns } from "./boxInvoicing.vue?vue&type=template&id=b3f89680&"
import script from "./boxInvoicing.vue?vue&type=script&lang=js&"
export * from "./boxInvoicing.vue?vue&type=script&lang=js&"
import style0 from "./boxInvoicing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports